/**
 * Wholesale logic
 */
console.log("Wholesale Scripts");

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
  
    return vars;
}
  
$(function() {
  
    /**
     *  Wholesale collection page
     */
    var $container = $('.wholesale-container');
  
    window.category_states = {
      
    };
  
    $(document).on('click', '.wholesale-form__clear', function(e) {
      e.preventDefault();
  
      $el = $(this);
  
      $el.html('Updating');
  
      $.get('/cart/clear', function() {
        refreshForm();
        $el.html('Clear Form');
      });
    });
  
    $(document).on('click', '.wholesale-form__category .toggle', function(e) {
      var id = $(this).closest('.wholesale-form__category').data('category-id');
      $(this).toggleClass('active');
      category_states[id] = (category_states[id]) ? null : true;
    });
    
    $(document).on('submit', '.wholesale-form__form', function(e) {
  
      e.preventDefault();
  
      var $qty = $(this).find('.wholesale-form__quantity');
      var $atc = $(this).find('.wholesale-form__submit');
      var variant_id = $(this).data('variant-id');
      var quantity = parseInt($qty.val()) || 1;
  
      $atc.val('Loading').attr('disabled', true);
  
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: 'quantity=' + quantity + '&id=' + variant_id,
        dataType: 'json',
        success: function(line_item) {
          $atc.val('Add to cart').attr('disabled', false).addClass('success');
          $qty.val(1);
  
          refreshForm();
  
          setTimeout(function() {
            $atc.removeClass('success');
          }, 700);
          setAttribute();
        },
        error: function(XMLHttpRequest, textStatus) {
          $atc.val('Add to cart').attr('disabled', false);
          $qty.val(1);
        }
      });
    });
  
    function refreshForm() {
      $.get('/collections/wholesale-products?view=wholesale-ajax', function(r) {
        $container.html(r);
        $.each(window.category_states, function(state, value) {
          if(value) {
            $('[data-category-id=' + state + '] .toggle').addClass('active');
          }
        });
      });
    }
  
    
  
    /**
     *  Wholesale customer registration
     */
    var params = getUrlVars();
    var submitted = false;
    var regParam = "wholesale";
    var has_tag = window.ws;
  
    var $atc = $('.form-submit');
  
    if(has_tag && params && params['type'] && params['type'] !== regParam) {
      $.post('/cart/update.js', {
        attributes: {
          'Wholesale': null
        }
      }, function() {
        window.location.reload();
      }, 'json');
    }
      
  
    if(params && params['type'] === regParam || has_tag) {
  
      if(!has_tag) {
        setAttribute(function() {
          window.location.reload();
        });
      }
  
      $(document).on('submit', '#create_customer', function(e) {
  
        if(!submitted) {
          e.preventDefault();
  
          var note = ['Wholesale Customer'];
          
          // Add wholesale field values to customer note input.
          $('.wholesale-field').each(function() {
            note.push($(this).data('label') + ': ' + $(this).val());
          });
  
          $('#wholesale_note').val(note.join(', '));
      
          submitted = true;
    
          $(this).submit();
        }
      });
    }
  
    function setAttribute(cb) {
      $.post('/cart/update.js', {
        attributes: {
          'Wholesale': 'Wholesale'
        }
      }, cb, 'json');
    }
  
    
  
    /**
     * Geolocation
     */
    $(document).on('change', '.country-toggle select', function(e) {
  
      e.preventDefault();
  
      $(this).attr('disabled', true).css('opacity', 0.6);
  
      $('.country-toggle__current').attr('src', $('select option:selected').data('img'));
  
      window.location.href = $(this).val() + window.location.pathname;
    });
  
    if(!Cookies.get('geolocated')) {
      $.get('//api.ipstack.com/check?access_key=c659ec4c68fddd0aeac28c4bf4a78abb', function(r) {
        var selected_country = $('.country-toggle option[selected]').data('country');
        if(r.country_code !== selected_country) {
          if(r.country_code == 'US') {
            $('.country-toggle option[data-country=US]').attr('selected', true).trigger('change');
          } else {
            $('.country-toggle option[data-country=CA]').attr('selected', true).trigger('change');
          }
  
          if(Cookies) {
            Cookies.set('geolocated', true, { expires: 5 });
          }
        }
      });
    }
});